<template>
    <page>
        <module>
            <view-list ref="view" :work-type="workType" :view-config="saasInfo.viewmanage">
                <template #search>
                    <m-search ref="search" :extend-data="defaultSearchData">
                        <m-search-item label="背贴码">
                            <m-code-batch-input name="produce_unique_codes" field-name="背贴码" placeholder="请输入背贴码，支持批量"></m-code-batch-input>
                        </m-search-item>
                        <m-search-item label="IMEI">
                            <m-code-batch-input name="produce_imeis" field-name="IMEI" placeholder="请输入IMEI，支持批量"></m-code-batch-input>
                        </m-search-item>
                        <m-search-item label="产品信息">
                            <c-input name="product_info" placeholder="品牌/型号/颜色/内存"></c-input>
                        </m-search-item>
                        <m-search-item label="采购人">
                            <c-input name="purchase_user_name"></c-input>
                        </m-search-item>
                        <m-search-item label="验机人">
                            <c-input name="quality_user_name"></c-input>
                        </m-search-item>
                        <m-search-item label="等级">
                            <c-select name="level_type" :options="LEVEL_TYPE"></c-select>
                        </m-search-item>
                        <m-search-item label="创建时间" colspan="2">
                            <c-datetime range start-name="create_date_start_date" end-name="create_date_end_date"></c-datetime>
                        </m-search-item>
                    </m-search>
                </template>
                <template #operate>
                    <c-button v-if="auth('b_high_stock_age_export')" prepend-icon="tf-export"
                              @click="$refs.view.exportListByViewId()">导出</c-button>
                </template>
                <!--商品信息-->
                <template #product_info="{data}">
                    <m-product-info :name="data.product_info || getProductText(data)" :level="data.level_type" :code="data.produce_unique_code" :imei="data.produce_imei" :old-imei="data.produce_imei_old"></m-product-info>
                </template>
                <!--背贴码主状态-->
                <template #main_state="{data}">
                    <c-state tag async dict="UNIQUE_CODE_MAIN_STATE" :value="data.main_state"></c-state>
                </template>
                <!--背贴码详细状态-->
                <template #state="{data}">
                    <c-state tag async dict="UNIQUE_CODE_STATE" :value="data.state"></c-state>
                </template>
                <!--关联单据-->
                <template #purchase_code="{data}">
                    <div class="m-product-info">
                        <p class="m-product-info-name">采购单：{{data.purchase_code}}</p>
                        <p class="m-product-info-name">三方订单号：{{data.out_order_number}}</p>
                    </div>
                </template>
                <!--价格信息-->
                <template #purchase_price="{data}">
                    <div class="m-product-info">
                        <p class="m-product-info-name">采购：￥{{data.purchase_price||0}}</p>
                        <p class="m-product-info-name">维修：￥{{data.repair_cost||0}}</p>
                    </div>
                </template>
                <!--是否拆机-->
                <template #is_dismantle="{data}">
                    <span v-if="data.is_dismantle == 1">拆</span>
                </template>
                <c-table-column
                        type="button"
                        label="操作"
                        width="150"
                        button-limit="6"
                >
                    <template #default="{data}">
                        <c-table-button v-if="auth('b_high_stock_age_remark_view')" icon="tf-detail" @click="showRemark(data)">查看备注</c-table-button>
                    </template>
                </c-table-column>
            </view-list>
            <!--查看备注弹窗-->
            <code-remark ref="codeRemark"></code-remark>
        </module>
    </page>
</template>

<script>
import {mapState} from 'vuex'
import {asyncMapState} from '@/store'
import codeRemark from "@/pages/storage/code_remark.vue";

export default {
    name: 'm_storage_ledger',

    components: {codeRemark},

    computed: {
        // 获取dictName选项数据
        ...asyncMapState(['LEVEL_TYPE']),
        ...mapState(['saasInfo','userInfo']),
    },

    data() {
        return {
            defaultSearchData: {
            },
            workType: 23                 //待入库商品列表
        }
    },
    methods: {
        /*********获取产品信息文字**********/
        getProductText(data) {
            var parts = [];
            if (data.brand_name) parts.push(data.brand_name);
            if (data.model_name) parts.push(data.model_name);
            if (data.memory_name) parts.push(data.memory_name);
            if (data.color_name) parts.push(data.color_name);
            return parts.join(' ') || '-';
        },
        /****展示备注****/
        showRemark(data) {
            this.$refs.codeRemark.open(data);
        }
    }
}
</script>
<style lang="stylus" scoped>
.m-product-info {
    line-height: 20px;
    font-size: 13px;
    color: #333;

    .m-product-info-name {
        display: flex;
        align-items: center;
        gap: 4px;
    }

    .m-product-info-code {
        color: #999;
        font-size: 12px;
    }
}

// 批量生成发货单预览
.m-batch-preview-body {
    display: flex;
    flex-direction: column;
    height: 100%;
}

.m-batch-preview {
    flex: 1;
    overflow-y: auto;
    min-height: 0;
    padding-right: 4px;

    .m-preview-group {
        background: #f7f8fa;
        border-radius: 4px;
        padding: 12px 16px;
        margin-bottom: 12px;

        .m-preview-header {
            display: flex;
            align-items: center;
            gap: 8px;
            margin-bottom: 10px;

            .m-preview-badge {
                padding: 2px 6px;
                border-radius: 2px;
                font-size: 12px;
                color: #fff;

                &.m-merge {
                    background: #3D5EFF;
                }

                &.m-single {
                    background: #07B461;
                }
            }

            .m-preview-receiver {
                flex: 1;
                font-size: 13px;
                color: #333;
                word-break: break-all;
            }

            .m-preview-total {
                font-size: 13px;
                color: #666;
                white-space: nowrap;
            }
        }

        .m-preview-orders {
            display: flex;
            flex-wrap: wrap;
            gap: 10px;

            .m-preview-order {
                background: #fff;
                border: 1px solid #e5e5e5;
                border-radius: 4px;
                padding: 6px 10px;
                display: flex;
                align-items: center;
                gap: 8px;
                font-size: 12px;
                color: #333;

                .m-preview-order-text {
                    word-break: break-all;
                }

                .m-preview-split {
                    color: #3D5EFF;
                    cursor: pointer;
                    display: inline-flex;
                    align-items: center;
                    flex-shrink: 0;

                    i {
                        font-size: 14px;
                        font-style: normal;
                    }

                    &:hover {
                        color: #5F7FFF;
                    }
                }
            }
        }
    }

    .m-preview-empty {
        text-align: center;
        color: #999;
        padding: 30px 0;
        font-size: 13px;
    }
}

.m-preview-footer {
    margin-top: 16px;
    font-size: 13px;
    color: #666;
}
</style>